
export default {
  props: {
    category: {
      type: Object,
      default: null
    }
  },
  vessel: {
    count: {
      fontWeight: 'semibold'
    }
  },
  computed: {
    title() {
      return {
        tag: 'h2',
        html: this.category.name,
        fontSize: 'md'
      }
    },
    text() {
      return {
        tag: 'div',
        html: this.category.excerpt,
        fontSize: 'md',
        fontWeight: 'light'
      }
    },
    image() {
      return {
        fit: 'contain',
        ratio: '4/3',
        height: 'auto',
        ...this.category.image
      }
    }
  },
  methods: {
    detailsLink() {
      const slug = this.category.slug
      const categories = this.$pagePath('categories')

      return `${categories}/${slug}`
    }
  }
}
